// document.addEventListener('DOMContentLoaded', function () {
//   const target = document.querySelector('.pagination');
  
//   if (target) {
//     const loadMoreLink = document.getElementById('loadMoreButton'); // Anchor tag instead of button
    
//     if (loadMoreLink) {
//       loadMoreLink.addEventListener('click', window.onClickCollectionPagination);
//     }

//     window.onClickCollectionPagination = async (link, event) => {
//       event.preventDefault();
      
//       // Disable the anchor tag and change its inner HTML to 'Loading'
//       link.style.pointerEvents = 'none'; // Disable further clicks
//       link.innerHTML = `
//         <div class="st-results-loader">Loading...</div>
//       `;

//       try {
//         const response = await fetch(link.getAttribute('href'));
//         const data = await response.text();
//         const parser = new DOMParser();
//         const newDocument = parser.parseFromString(data, 'text/html');

//         // Append the new products to the list
//         document.querySelector('.product-list')
//           .insertAdjacentHTML('beforeend', newDocument.querySelector('.product-list').innerHTML);

//         // Replace the pagination with the new pagination
//         document.querySelector('.pagination')
//           .replaceWith(newDocument.querySelector('.pagination'));
        
//         // Re-enable the link after the process is complete
//         link.style.pointerEvents = 'auto'; // Re-enable clicks
//         link.innerHTML = `
//           <div class="st-results-loader">Load More</div>
//         `;
//         // Only observe if observer1 exists (check to prevent TypeError)
//         if (window.observer1 && typeof window.observer1.observe === 'function') {
//           const paginationElement = document.querySelector('.pagination');
//           if (paginationElement) {
//             window.observer1.observe(paginationElement);
//           }
//         }
//       } catch (error) {
//         console.error('Error loading more content:', error);
//         // Optionally, you can re-enable the link in case of error
//         link.style.pointerEvents = 'auto';
//         link.innerHTML = 'Load More'; // Or show an error message
//       }
//     };
//   }
// });



function toggleProductGrid(lines) {
    
    const productGrid = document.querySelector('.product-list');
    
    productGrid.classList.remove('collection__page-products-6');
    productGrid.classList.remove('collection__page-products');
    productGrid.classList.remove('collection__page-products-3');
    productGrid.classList.remove('collection__page-products-2');
    productGrid.classList.remove('collection__page-products-1');
  
    
     if (lines === 3) {
        productGrid.classList.add('collection__page-products-3');
    } else if (lines === 6) {
        productGrid.classList.add('collection__page-products-6');
    }else if (lines === 4) {
        productGrid.classList.add('collection__page-products');
    }
  else if (lines === 2) {
        productGrid.classList.add('collection__page-products-2');
    }
  else if (lines === 1) {
        productGrid.classList.add('collection__page-products-1');
    }
    const gridButtons = document.querySelectorAll('.st-grid-changer button');
const currentColumns = parseInt(lines); // Assuming 'lines' is the variable containing the current column value

gridButtons.forEach(button => {
    const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
    const isActive = button.classList.contains('active');

    if (buttonColumns === currentColumns && !isActive) {
        button.classList.add('active'); // Add 'active' class
    } else if (buttonColumns !== currentColumns && isActive) {
        button.classList.remove('active'); // Remove 'active' class
    }
});

}

document.addEventListener('DOMContentLoaded', () => {
    const productGrid = document.getElementById('product-list-template--24194487255411__main');
    const gridButtons = document.querySelectorAll('.st-grid-changer button');

    if (window.innerWidth <= 768) { 
        gridButtons.forEach(button => {
            const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
            if (buttonColumns === 2) {
                button.classList.add('active'); // Add 'active' class to button for collection__page-products-1
            } else {
                button.classList.remove('active'); // Remove 'active' from other buttons
            }
        });
       if (productGrid) {
            productGrid.classList.remove('collection__page-products-1'); // Mobile-specific class removal
        }
    }
});